// extracted by mini-css-extract-plugin
module.exports = {"emptyDivForDepthEffect":"ParallaxCardHover_emptyDivForDepthEffect__8LHhD"};